export const SHOW_HISTORY_BUTTON_LABEL="Show History";
export const HIDE_HISTORY_BUTTON_LABEL= "Hide History";

